import Axios from '@/utils/axios';
import { getBackendErrorMessage } from '@/utils/errorHandler';

export interface User {
  id: string;
  name: string;
  email: string;
  role?: string;
  department?: string;
  isActive?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface UserListRequest {
  page?: string;
  size?: string;
  search?: string;
  role?: string;
  department?: string;
  isActive?: boolean;
}

export interface UserListResponse {
  data: User[];
  pagination?: {
    page: number;
    size: number;
    total: number;
    totalPages: number;
  };
}

export const getListUser = async (
  params?: UserListRequest
): Promise<UserListResponse> => {
  try {
    const response = await Axios.get('/mgmt/v1/users', { params });
    return response.data;
  } catch (error: any) {
    const backendMessage = getBackendErrorMessage(error);
    throw new Error(backendMessage);
  }
};

export const getUserById = async (userId: string): Promise<User> => {
  try {
    const response = await Axios.get(`/mgmt/v1/users/${userId}`);
    return response.data;
  } catch (error: any) {
    const backendMessage = getBackendErrorMessage(error);
    throw new Error(backendMessage);
  }
};

export const createUser = async (
  data: Omit<User, 'ID' | 'createdAt' | 'updatedAt'>
): Promise<User> => {
  try {
    const response = await Axios.post('/mgmt/v1/users', data);
    return response.data;
  } catch (error: any) {
    const backendMessage = getBackendErrorMessage(error);
    throw new Error(backendMessage);
  }
};

export const updateUser = async (
  userId: string,
  data: Partial<User>
): Promise<User> => {
  try {
    const response = await Axios.put(`/mgmt/v1/users/${userId}`, data);
    return response.data;
  } catch (error: any) {
    const backendMessage = getBackendErrorMessage(error);
    throw new Error(backendMessage);
  }
};

export const deleteUser = async (userId: string): Promise<void> => {
  try {
    await Axios.delete(`/mgmt/v1/users/${userId}`);
  } catch (error: any) {
    const backendMessage = getBackendErrorMessage(error);
    throw new Error(backendMessage);
  }
};
